import { getRequiredMessage, Maybe } from '@monetize/types/common';
import { z } from 'zod';
import { IPaymentMethodContactSchema } from './paymentMethod.types';

export interface IShareInvoiceGenerateSetupIntentResp {
  clientSecret: string;
  publicKey: string;
}

// from POST /api/share/invoices/{invoiceShareSecret}/startPayment
export interface ISharedInvoicePaymentReq {
  amount: number;
  paymentToken: string;
  paymentMethodName?: Maybe<string>;
  description?: string;
  billingDetails: IPaymentMethodContactSchema;
}

export const StripePaymentMethodDataSchema = z.object({
  empty: z.boolean(),
  complete: z.boolean(),
  type: z.string(),
});
export type StripePaymentMethodData = z.infer<
  typeof StripePaymentMethodDataSchema
>;

export const SharedInvoicePaymentSchemaUI = z.object({
  amount: z.number().nonnegative('Must be a positive number'),
  billingDetails: z.object({
    // No longer in use on FE - BE will generate when missing
    paymentMethodName: z.string().nullish(),
    fullName: z.string().min(1, { message: getRequiredMessage('Name') }),
    email: z.email().min(1, { message: getRequiredMessage('Email') }),
  }),
  stripePublicKey: z.string(),
  stripeData: StripePaymentMethodDataSchema,
});

export type ISharedInvoicePaymentUI = z.infer<
  typeof SharedInvoicePaymentSchemaUI
>;

export const SharedInvoicePaymentExistingMethodSchema = z.object({
  amount: z.number().nonnegative('Must be a positive number'),
  paymentMethodId: z
    .string()
    .min(1, { message: getRequiredMessage('Payment Method') }),
});

export type SharedInvoicePaymentExistingMethod = z.infer<
  typeof SharedInvoicePaymentExistingMethodSchema
>;
